import { Images } from "../../../Images";
import TileMinedLogic from "../../../logic/TileMinedLogic";
import MissilesSkillRenderer from "../../../view/canvas/MissilesSkillRenderer";
import Totals from "../../crew/Totals";
import WorldGrid from "../../grid/WorldGrid";
import BigNum from "../../math/BigNum";
import Missiles from "./Missiles";
import GervaisAnimatedSpritesheet from "../../sprite/GervaisAnimatedSpritesheet";
import NumberValue from "../../value/NumberValue";
import SkillType from "../SkillType";
import AddMinerSkillNode from "../common/AddMInerSkillNode";
import { SkillIds } from "../SkillIds";
import PartyCharacter from "../../character/PartyCharacter";
import CoolDownSkillNode from "../common/CoolDownSkillNode";
import DurationSkillNode from "../common/DurationSkillNode";
import MoreMissilesSkillNode from "./MoreMissilesSkillNode";
import { Settings } from "../../../Settings";
import VectorField from "../../grid/VectorField";
import Values from "../../value/Values";

export default class MissileSkill extends SkillType {
    /**
     * @param {WorldGrid} worldGrid 
     * @param {Totals} totals
     * @param {TileMinedLogic} tileMinedLogic 
     * @param {Crew} crew
     * @param {VectorField} vectorField
     * @param {Values} values
     * @param {GervaisAnimatedSpritesheet} spellFxSpritesheet
     */
    constructor(worldGrid, totals, tileMinedLogic, crew, vectorField, values, spellFxSpritesheet) {
        super(SkillIds.MISSILE);

        /**
         * @constant
         * @type {WorldGrid}
         */
        this.worldGrid = worldGrid;
        /**
         * @constant
         * @type {TileMinedLogic}
         */
        this.tileMinedLogic = tileMinedLogic;
        /**
         * @constant
         * @type {VectorField}
         */
        this.vectorField = vectorField;
        /**
         * @constant
         * @type {Values}
         */
        this.values = values;
        /**
         * @constant
         * @type {NumberValue}
         */
        this.missilesUpgrades = new NumberValue(null, 0);

        /**
         * @constant
         * @type {Missiles[]}
         */
        this.missilesArray = [];

        /**
         * @constant
         * @type {Object}
         */
        this.missilesByCharacter = {};

        /**
         * @constant
         * @type {MissilesSkillRenderer}
         */
        this.renderer = new MissilesSkillRenderer(this.missilesArray, spellFxSpritesheet);

        /////////////////////////

        let cost = 1;


        const addMinerNode1 = this.addNode(new AddMinerSkillNode('addMissileMiner1', '+1 Missile Miner', 'Fire volleys of missiles', 
            totals, Images.skill.missiles, new BigNum(cost + Settings.skill.costs.addMissile1), this, crew, SkillIds.MISSILE
        ));

        ////////////////////////////
        // Cost Tier 2
        ////////////////////////////

        cost++;

        const missileBonus1 = this.addNode(new MoreMissilesSkillNode('missileBonus1', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.missilesUpgrades
        ));

        const coolBonus1 = this.addNode(new CoolDownSkillNode('missileCool1', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus1 = this.addNode(new DurationSkillNode('missileDur1', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        ////////////////////////////
        // Cost Tier 3
        ////////////////////////////
        
        cost++;

        const missileBonus2 = this.addNode(new MoreMissilesSkillNode('missileBonus2', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.missilesUpgrades
        ));

        const coolBonus2 = this.addNode(new CoolDownSkillNode('missileCool2', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus2 = this.addNode(new DurationSkillNode('missileDur2', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        ////////////////////////////
        // Cost Tier 4
        ////////////////////////////
        
        cost++;

        const missileBonus3 = this.addNode(new MoreMissilesSkillNode('missileBonus3', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.missilesUpgrades
        ));
    
        const coolBonus3 = this.addNode(new CoolDownSkillNode('missileCool3', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus3 = this.addNode(new DurationSkillNode('missileDur3', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        const addMinerNode2 = this.addNode(new AddMinerSkillNode('addMissileMiner2', '+1 Missile Miner', 'Fire volleys of missiles', 
            totals, Images.skill.missiles, new BigNum(cost + Settings.skill.costs.addMiner2), this, crew, SkillIds.MISSILE
        ));

        ////////////////////////////
        // Cost Tier 5
        ////////////////////////////
        
        cost++;

        const missileBonus4 = this.addNode(new MoreMissilesSkillNode('missileBonus4', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.missilesUpgrades
        ));

        const coolBonus4 = this.addNode(new CoolDownSkillNode('missileCool4', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus4 = this.addNode(new DurationSkillNode('missileDur4', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        ////////////////////////////
        // Cost Tier 6
        ////////////////////////////
        
        cost++;

        const missileBonus5 = this.addNode(new MoreMissilesSkillNode('missileBonus5', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.missilesUpgrades
        ));

        const coolBonus5 = this.addNode(new CoolDownSkillNode('missileCool5', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus5 = this.addNode(new DurationSkillNode('missileDur5', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        ////////////////////////////
        // Cost Tier 7
        ////////////////////////////
        
        cost++;

        const missileBonus6 = this.addNode(new MoreMissilesSkillNode('missileBonus6', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.missilesUpgrades
        ));

        const coolBonus6 = this.addNode(new CoolDownSkillNode('missileCool6', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus6 = this.addNode(new DurationSkillNode('missileDur6', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        const addMinerNode3 = this.addNode(new AddMinerSkillNode('addMissileMiner3', '+1 Missile Miner', 'Fire volleys of missiles', 
            totals, Images.skill.missiles, new BigNum(cost + Settings.skill.costs.addMiner3), this, crew, SkillIds.MISSILE
        ));


        ////////////////////////////
        // Cost Tier 8
        ////////////////////////////
        
        cost++;

        const missileBonus7 = this.addNode(new MoreMissilesSkillNode('missileBonus7', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.missilesUpgrades
        ));

        const coolBonus7 = this.addNode(new CoolDownSkillNode('missileCool7', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus7 = this.addNode(new DurationSkillNode('missileDur7', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        ////////////////////////////
        // Cost Tier 9
        ////////////////////////////
        
        cost++;

        const missileBonus8 = this.addNode(new MoreMissilesSkillNode('missileBonus8', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.missilesUpgrades
        ));

        const coolBonus8 = this.addNode(new CoolDownSkillNode('missileCool8', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus8 = this.addNode(new DurationSkillNode('missileDur8', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        ////////////////////////////
        // Cost Tier 10
        ////////////////////////////

        cost++;

        const missileBonus9 = this.addNode(new MoreMissilesSkillNode('missileBonus9', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.missilesUpgrades
        ));

        const coolBonus9 = this.addNode(new CoolDownSkillNode('missileCool9', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus9 = this.addNode(new DurationSkillNode('missileDur9', 
            totals, Images.skill.missiles, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        const addMinerNode4 = this.addNode(new AddMinerSkillNode('addMissileMiner4', '+1 Missile Miner', 'Fire volleys of missiles', 
            totals, Images.skill.missiles, new BigNum(cost + Settings.skill.costs.addMiner4), this, crew, SkillIds.MISSILE
        ));

        ///////////////////////////////////
        // Setup node relationships
        ///////////////////////////////////

        addMinerNode1.addChildNode(missileBonus1);
        
        // All the missile bonus nodes are directly descended from each other
        missileBonus1.addChildNode(missileBonus2);
        missileBonus2.addChildNode(missileBonus3);
        missileBonus3.addChildNode(missileBonus4);
        missileBonus4.addChildNode(missileBonus5);
        missileBonus5.addChildNode(missileBonus6);
        missileBonus6.addChildNode(missileBonus7);
        missileBonus7.addChildNode(missileBonus8);
        missileBonus8.addChildNode(missileBonus9);
        
        missileBonus1.addChildNode(coolBonus1);
        missileBonus2.addChildNode(coolBonus2);
        missileBonus3.addChildNode(coolBonus3);
        missileBonus4.addChildNode(coolBonus4);
        missileBonus5.addChildNode(coolBonus5);
        missileBonus6.addChildNode(coolBonus6);
        missileBonus7.addChildNode(coolBonus7);
        missileBonus8.addChildNode(coolBonus8);
        missileBonus9.addChildNode(coolBonus9);

        coolBonus1.addChildNode(durationBonus1);
        coolBonus2.addChildNode(durationBonus2);
        coolBonus3.addChildNode(durationBonus3);
        coolBonus4.addChildNode(durationBonus4);
        coolBonus5.addChildNode(durationBonus5);
        coolBonus6.addChildNode(durationBonus6);
        coolBonus7.addChildNode(durationBonus7);
        coolBonus8.addChildNode(durationBonus8);
        coolBonus9.addChildNode(durationBonus9);

        missileBonus3.addChildNode(addMinerNode2);
        missileBonus6.addChildNode(addMinerNode3);
        missileBonus9.addChildNode(addMinerNode4);

        ///////////////////////////////////
        // Position the nodes in the graph
        ///////////////////////////////////

        // Starting coordinate of the skill
        const startX = 3;
        const startY = -3;

        // unlockNode.setPosition(startX, startY);
        addMinerNode1.setPosition(startX, startY);

        missileBonus1.setPosition(startX + 1, startY);
        missileBonus2.setPosition(startX + 2, startY);
        missileBonus3.setPosition(startX + 3, startY);
        missileBonus4.setPosition(startX + 4, startY);
        missileBonus5.setPosition(startX + 5, startY);
        missileBonus6.setPosition(startX + 6, startY);
        missileBonus7.setPosition(startX + 7, startY);
        missileBonus8.setPosition(startX + 8, startY);
        missileBonus9.setPosition(startX + 9, startY);

        coolBonus1.setPosition(startX + 1, startY - 1);
        coolBonus2.setPosition(startX + 2, startY - 1);
        coolBonus3.setPosition(startX + 3, startY - 1);
        coolBonus4.setPosition(startX + 4, startY - 1);
        coolBonus5.setPosition(startX + 5, startY - 1);
        coolBonus6.setPosition(startX + 6, startY - 1);
        coolBonus7.setPosition(startX + 7, startY - 1);
        coolBonus8.setPosition(startX + 8, startY - 1);
        coolBonus9.setPosition(startX + 9, startY - 1);

        durationBonus1.setPosition(startX + 1, startY - 2);
        durationBonus2.setPosition(startX + 2, startY - 2);
        durationBonus3.setPosition(startX + 3, startY - 2);
        durationBonus4.setPosition(startX + 4, startY - 2);
        durationBonus5.setPosition(startX + 5, startY - 2);
        durationBonus6.setPosition(startX + 6, startY - 2);
        durationBonus7.setPosition(startX + 7, startY - 2);
        durationBonus8.setPosition(startX + 8, startY - 2);
        durationBonus9.setPosition(startX + 9, startY - 2);

        addMinerNode2.setPosition(startX + 3, startY + 1); // below missileBonus3
        addMinerNode3.setPosition(startX + 6, startY + 1); // below missileBonus6
        addMinerNode4.setPosition(startX + 9, startY + 1); // below missileBonus9

    }

    /**
     * @override
     * @param {PartyCharacter} miner
     * @param {number} frameTimeRatio 
     * @param {boolean} skillActive
     */
    updateSkillForFrame(miner, frameTimeRatio, skillActive) {
        // Each miner has their own instance of the Missiles object.


        /**
         * @type {Missiles}
         */
        let missiles = this.missilesByCharacter[miner.id];
        if (!missiles) {
            missiles = new Missiles(this.worldGrid, this.vectorField, this.missilesUpgrades, this.tileMinedLogic, this.values);
            this.missilesByCharacter[miner.id] = missiles;
            this.missilesArray.push(missiles);
        }

        // If the activation value has changed, then notify the missiles object
        if (skillActive && !missiles.skillActive) {
            missiles.onSkillActivation();
        }
        else if (!skillActive && missiles.skillActive) {
            missiles.onSkillDeactivation();
        }

        if (skillActive) {
            missiles.updateForFrame(miner, frameTimeRatio);
        }
    }

    /**
     * @override
     * @returns {SkillRenderer}
     */
    getRenderer() {
        return this.renderer;
    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        super.resetFull();

        this.missilesArray.length = 0;
        this.missilesByCharacter = {};

        this.missilesUpgrades.reset();
    }

}